import { Layout } from "@/components";
import ProtectedRoute from "../ProtectedRoute";
import { routes } from "../utils";
import { Navigate } from "react-router-dom";
import { PmDashboard } from "@/pages";
import { Role, roles } from "@/lib/utils";
import { ProjectOverviewRoutes } from "./ProjectOverviewRoutes";

const PMRoutes = () => {
  return {
    path: routes.pm,
    element: (
      <ProtectedRoute
        allowedRoles={[roles.pm.value as Role]}
      />
    ),
    children: [
      {
        path: "",
        element: <Layout />,
        children: [
          {
            path: "",
            element: <Navigate to={`/${routes.pm}/${routes.dashboard}`} />,
          },
          {
            path: routes.dashboard,
            element: <PmDashboard />,
          },
          ProjectOverviewRoutes(),
        ],
      },
    ],
  };
};

export default PMRoutes;
